var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccount = function SvgAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 2.5V15L10 19.167 2.5 15V2.5L10 .833zM9.167 9.167a2.5 2.5 0 0 0-2.5 2.5v1.666h6.666v-1.666a2.5 2.5 0 0 0-2.5-2.5zM10 5a1.667 1.667 0 1 0 0 3.334A1.667 1.667 0 0 0 10 5"
  })));
};
export default SvgAccount;